import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { NgbModalOptions, NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Workspace } from "../../../model/workspace.data";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { IParameters } from "../../../interfaces/IParameters";
import * as $ from "jquery";

import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { strategyCellRendererComponent } from "../../../renderers/strategyCellRendererComponent.component";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { callNextAsync } from "../../../services/BaseService";

@Component({
    selector: "SelectedParametersSetModal",
    template: require('./SelectedParametersSet.component.html'),
    styles: [require('./SelectedParametersSet.component.css'), require('../SavedStrategiesModal/SavedStrategiesModal.component.css')]
})
export class SelectedParametersSetComponent extends AppComponentBase implements OnInit, AfterViewInit {
    addToExisting: boolean = false;

    selectedOption: string = "test2";

    @ViewChild("ParametersSetNameNew")
    ParametersSetNameNew!: ElementRef;

    get userParameterSets() {
        let source = this.workspace.userSets;
        let map = Object.keys(this.workspace.userSets)
            .filter(v => {
                if (v.substr(0, 1) != "m") {
                    return v;
                }
            })
            .map(function(name) {
                return {
                    id: name,
                    name: source[name]
                };
            });

        return map;
    }

    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        private globalGridModeService: GlobalGridModeService,
        private ngbModalService: NgbModal
    ) {
        super(injector);

        /*********GRID */

        this.gridOptions = <GridOptions>{};
        this.gridOptions.defaultColDef = {
            cellClass: "orders-cell"
            // width:150,
        };

        this.gridOptions.enableFilter = true;
        this.rowSelection = "single";

        this.globalGridModeService.sendModelChangeParametersSet.subscribe(v => {
            console.log("SAVEDNEWSTRATEGY");
            this.refreshGridData();
            this.seletedRowParameterSetId = "";
        });

        /***************GRID* */
    }

    ifNotEmptyGetValue(value: string | undefined, defaultValue: string) {
        return value && value.trim() != "" ? value : defaultValue;
    }

    ngOnInit() {}
    ngAfterViewInit(): void {
        //   $(".container-strategies").mCustomScrollbar({
        //     axis: "y",
        //     theme: "inset-3", // "minimal-dark",
        //     scrollbarPosition: "outside",
        //     alwaysShowScrollbar: 1, // 0,1,2
        //     scrollButtons: {
        //         enable: true
        //     },
        //     mouseWheel: {
        //         enable: true
        //     }
        // });
    }

    private _ParametersSetToRename: string = "";
    public get ParametersSetToRename(): string {
        return this._ParametersSetToRename;
    }
    public set ParametersSetToRename(value: string) {
        this._ParametersSetToRename = value;
    }

    private _ParametersSetToSave: string = "";
    public get ParametersSetToSave(): string {
        return this._ParametersSetToSave;
    }
    public set ParametersSetToSave(value: string) {
        this._ParametersSetToSave = value;
    }

    initForm(type: string = "standard", Id: string = "") {
        this.selectedOption = "";
        this.modalSubType = type;
        this.ParametersSetToDelete = Id;
        this.ParametersSetToSave = Id;

        if (type == "renameParametersSet") {
            this.ParametersSetToRename = Id;
        }
    }

    /***NEW ITEMS */
    private _modalSubType: string = "standard";
    public get modalSubType(): string {
        return this._modalSubType;
    }
    public set modalSubType(value: string) {
        this._modalSubType = value;
    }
    private _newParametersSetName: string = "";
    public get newParametersSetName(): string {
        return this._newParametersSetName;
    }
    public set newParametersSetName(value: string) {
        this._newParametersSetName = value;
    }

    saveNewParametersSet(activeModal: NgbActiveModal) {
        var id = this.workspace.addNewSet(this.newParametersSetName);
        // this.workspace.userSetSave(id, false);

        callNextAsync(this.globalGridModeService.sendModelChangeParametersSet, true).then(() => {
            activeModal.close();
        });
    }

    saveParametersSet(ParametersSetToSave: string) {
        // this.workspace.addNewSet(this.workspace.userSets[ParametersSetToSave], ParametersSetToSave);
        // if nothing to save then no request to server
        this.workspace
            .userSetSave(ParametersSetToSave, true)
            .then(r => {
                this.toastrHelper.showSuccess("Settings", "Your setting where saved", true);
                this.activeModal.close();
            })
            .catch(error => {
                console.error(error);
                this.activeModal.close();
            });
    }

    loadParametersSet(ParametersSetId: string, addToExisting: boolean) {
        this.workspace.selectedSet = ParametersSetId;
        this.workspace
            .userSetload(ParametersSetId)
            .then(response => {
                this.activeModal.close();
            })
            .catch(error => {
                console.error(error);
            });
    }

    private _ParametersSetToDelete: string = "";
    public get ParametersSetToDelete(): string {
        return this._ParametersSetToDelete;
    }
    public set ParametersSetToDelete(value: string) {
        this._ParametersSetToDelete = value;
    }

    deleteSelelectedParametersSet(ParametersSetId: string) {
        this.workspace.deleteUserSet(ParametersSetId);
        callNextAsync(this.globalGridModeService.sendModelChangeParametersSet, true).then(() => {
            this.activeModal.close();
        });
    }

    renameParametersSet(ParametersSetToRename: string) {
        this.workspace.changeSetName(ParametersSetToRename, this.newParametersSetName);
        callNextAsync(this.globalGridModeService.sendModelChangeParametersSet, true).then(() => {
            this.activeModal.close();
        });
    }
    public showModalFooter = false;
    /*****************************GRID */

    private _seletedRowParameterSetId: string = "";
    public get seletedRowParameterSetId(): string {
        return this._seletedRowParameterSetId;
    }
    public set seletedRowParameterSetId(value: string) {
        this._seletedRowParameterSetId = value;
    }

    columnDefs = [
        {
            headerName: "Name",
            field: "name",
            width: 255,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
        {
            headerName: " ",
            width: 60,
            cellStyle: { "text-align": "left", "padding-left": "5px !important;" },
            cellRendererFramework: strategyCellRendererComponent,
            cellRendererParams: {
                edit: this.editAction,
                delete: this.deleteAction,
                modalService: this.ngbModalService
            }
        }
    ];

    public gridOptions: GridOptions;
    public rowSelection: any;
    private gridApi: any;
    private gridColumnApi: any;

    editAction(params: any) {
        ShowRenameParametersSetModal(this.modalService, params.data.id);
    }

    deleteAction(params: any) {
        ShowDeleteParametersSetModal(this.modalService, params.data.id);
    }

    getRowNodeId(data: any) {
        return data.id;
    }

    public onGridReady(params: GridOptions) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        if (this.gridApi) this.gridApi.setRowData([]);

        this.refreshGridData();
    }

    refreshGridData() {
        if (this.gridApi) {
            this.gridApi.setRowData([]);
            this.gridApi.updateRowData({ add: this.userParameterSets });
            this.gridApi.clearFocusedCell();
        }
    }

    public onSelectionChanged(e: any) {
        if (this.gridApi !== undefined) {
            let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);

            if (row !== undefined) this.seletedRowParameterSetId = row.data.id;
        }
    }

    /*****************END GRID**************** */

    showAddNewParametersSetwindow(event: any) {
        event.stopPropagation();
        ShowAddNewParametersSetModal(this.modalService);
    }

    showsaveParametersSetwindow(event: any, id: string) {
        event.stopPropagation();
        ShowSaveParametersSetModal(this.modalService, id);
    }
}

export function SelectedParametersSetModal(modalService: NgbModal) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(SelectedParametersSetComponent, opt);
    (<SelectedParametersSetComponent>m.componentInstance).initForm();

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowAddNewParametersSetModal(modalService: NgbModal) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(SelectedParametersSetComponent, opt);
    (<SelectedParametersSetComponent>m.componentInstance).initForm("addNewParametersSet", "");

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowDeleteParametersSetModal(modalService: NgbModal, deletingParametersSetId: string) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(SelectedParametersSetComponent, opt);
    (<SelectedParametersSetComponent>m.componentInstance).initForm("deleteParametersSet", deletingParametersSetId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowSaveParametersSetModal(modalService: NgbModal, saveParametersSetId: string) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(SelectedParametersSetComponent, opt);
    (<SelectedParametersSetComponent>m.componentInstance).initForm("saveParametersSet", saveParametersSetId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}

export function ShowRenameParametersSetModal(modalService: NgbModal, renameParametersSetId: string) {
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: "dark-modal",
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(SelectedParametersSetComponent, opt);
    (<SelectedParametersSetComponent>m.componentInstance).initForm("renameParametersSet", renameParametersSetId);

    m.result
        .then((formGroup: FormGroup) => {})
        .catch(reason => {
            console.error(reason);
        });
}
